module.exports = __webpack_public_path__ + "static/media/PaymentP&EScreen.f5ef59b0.png";